import { createSelector } from 'reselect';
import { RegionDto } from '@trucktrax/trucktrax-ts-common';
import { ReduxState } from '..';
import { HasNameAndUrl } from '../../types';

const selectRegionList = (state: Pick<ReduxState, 'regionList'>) => state.regionList ?? [];
const selectDeactivatedRegionList = (state: Pick<ReduxState, 'deactivatedRegionList'>) =>
  state.deactivatedRegionList ?? [];

export const activeAndDeactivatedRegionsSelector = createSelector(
  [selectRegionList, selectDeactivatedRegionList],
  (regionList, deactivatedRegionList): RegionDto[] => [...regionList, ...deactivatedRegionList],
);

const selectAssignedRegionList = (state: Pick<ReduxState, 'assignedRegionList'>) =>
  state.assignedRegionList ?? [];

export const assignedAndDeactivatedRegionsSelector = createSelector(
  [selectAssignedRegionList, selectDeactivatedRegionList],
  (assignedRegionList, deactivatedRegionList): HasNameAndUrl[] => [
    ...assignedRegionList,
    ...deactivatedRegionList.filter(
      deactivated => !assignedRegionList.some(assigned => assigned.url === deactivated.url),
    ),
  ],
);
